import React, { useState, useEffect } from 'react'
import AdminHeader from '../../components/Header/AdminHeader'
import AdminSideBar from '../../components/SideBar/AdminSideBar'
import AdminFooter from '../../components/Footer/AdminFooter'
import eventmanagedetailStyle from './EventManagementDetailsPage.module.css'
import authorImg from '../../../assets/images/men-img.png'
import { format } from 'date-fns';
import BackBar from '../../components/BackBar/BackBar';
import { Link } from 'react-router-dom';
import { FaMagnifyingGlass } from "react-icons/fa6";
import { useNavigate, useParams } from 'react-router-dom';
import axios from "axios";
import { DatePicker } from 'rsuite';
import Swal from "sweetalert2";

export default function EventManagementDetailsPage() {
  const [orderingEnd, setOrderingEnd] = useState(null);
  const [eventData, setEventData] = useState(null);
  const [eventBookData, setEventBookData] = useState([]);
  const formattedOrderingEnd = orderingEnd
    ? format(new Date(orderingEnd), 'MM/dd/yyyy')
    : '';
  const [updatedOrderingDate, setUpdatedOrderingDate] = useState("");
  //const [orderingEnd, setOrderingEnd] = useState('');
  const [textInput, setTextInput] = useState('');
  const [notes, setNotes] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  // console.log('cid:',id);
  const navigate = useNavigate();



  useEffect(() => {


    const fetchCoordinatorData = async () => {
      try {

        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_cordinator_event_data_admin.php?id=${id}`);
        const data = await response.json();
        // console.log("data", data);


        if (data.success) {
          setEventData(data?.eventsdata);
          setEventBookData(JSON.parse(data.eventsdata.book_data));

          //setNotes(data.eventsdata['note']);
          setNotes(data.eventsdata.event_notes || '');
        } else {
          setError(data.message);
        }
      } catch (err) {
        setError('Failed to fetch coordinator data.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchCoordinatorData();
  }, [id]);

  const convertToMySQLDate = (dateStr) => {
    const [month, day, year] = dateStr.split("/");
    return `${year}-${month}-${day}`;
  };

  const handleSaveOrderingWindow = async () => {
    if (!orderingEnd) {
      Swal.fire("Error", "Please select a date", "warning");
      return;
    }

    // Convert Date → YYYY-MM-DD (MySQL format)
    const formattedDate = format(orderingEnd, "yyyy-MM-dd");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/update_event_ordering_window.php`,
        {
          event_id: id,
          ordering_end_date: formattedDate,
        }
      );

      if (response.data.success) {
        setUpdatedOrderingDate(orderingEnd);

        Swal.fire({
          title: "Updated!",
          text: "Ordering window updated successfully",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          window.location.reload(); //  Reload page after success
        });
      } else {
        Swal.fire("Error", "Failed to update ordering window", "error");
      }
    } catch (err) {
      Swal.fire("Error", "Server error", "error");
    }
  };



  const formatToMMDDYYYY = (dateValue) => {
    if (!dateValue) return "";

    const date = new Date(dateValue);
    if (isNaN(date)) return "";

    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${mm}/${dd}/${yyyy}`;
  };

  const handleClick = () => {
    navigate('/EventManagementPage'); // Navigate to the Event Management Page
  };

  const handleNotesChange = (e) => {
    setNotes(e.target.value); // Update notes state
  };

  const handleSaveNotes = async (e) => {
    e.preventDefault();

    if (notes.trim() === "") {
      alert("Please enter some notes!");
      return;
    }

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/save_note_event_data_admin.php`, {
        event_id: id,
        notes: notes,
      });

      if (response.data.success) {
        Swal.fire({
          title: "Note!",
          text: "Note Saved Successfully!",
          icon: "success",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          // Update the eventData with the newly saved note
          setEventData((prevEventData) => ({
            ...prevEventData,
            event_notes: notes,
          }));
          // Optionally reset the notes field
          setNotes(notes); // Ensure the saved note is in sync with the textarea
        });
      } else {
        Swal.fire({
          title: "Note!",
          text: "Something went wrong!",
          icon: "error",
          timer: 2000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error('Error saving notes:', error);
      Swal.fire({
        title: "Note!",
        text: "Server Error!",
        icon: "error",
        timer: 2000,
        showConfirmButton: false,
      });
    }
  };

  const formatDate = (dateValue) => {
    if (!dateValue) return '';

    const date = new Date(dateValue);
    if (isNaN(date)) return '';

    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();

    return `${mm}/${dd}/${yyyy}`;
  };

  const formatTime = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
    });
  };

  const handleActivate = async (flag) => {
    let title = '';
    let text = '';
    if (flag == 'Approved') {
      title = 'Approved events!';
      text = 'Event Approved Successfully!';
    }
    if (flag == 'Not Approved') {
      title = 'Not Approved events!';
      text = 'Event Not Approved Successfully!';
    }
    if (flag == 'Waiting for Approval') {
      title = 'Waiting for Approval!';
      text = 'Event Not Approved Successfully!';
    }

    try {
      // Make the API call to activate the school
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}authormeetapi/get_cordinator_event_data_admin.php?eid=${id}&e_approve_flag=${flag}`);
      const data = await response.json();
      if (data.success) {
        Swal.fire({
          title: title,
          text: text,
          icon: "success",
          timer: 2000, // Pop-up duration in milliseconds
          showConfirmButton: false, // No need for a confirmation button
        }).then(() => {
          // Redirect after pop-up
          // navigate(`/ActivatedSchoolsOrgPage`);
          window.location.reload();
        });
      }
      else {
        Swal.fire({
          title: "Failed!",
          text: "Failed to activate or deactivate Cordinator!",
          icon: "error",
          timer: 2000, // Pop-up duration in milliseconds
          showConfirmButton: false, // No need for a confirmation button
        })
      }
    } catch (error) {
      console.error('Error activating school:', error);
      alert('Failed to activate school. Please try again.');
    }
  };

  function OrderingWindowInput() {
    const [orderingEnd, setOrderingEnd] = useState(''); // ISO format: YYYY-MM-DD or empty
    const [textInput, setTextInput] = useState('');

    // Helper: format ISO date string to MM/DD/YYYY
    const formatDate = (isoDate) => {
      if (!isoDate) return '';
      const d = new Date(isoDate);
      if (isNaN(d)) return '';
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const yyyy = d.getFullYear();
      return `${mm}/${dd}/${yyyy}`;
    };
  }

  const parseDate = (str) => {
    const [mm, dd, yyyy] = str.split('/');
    if (!mm || !dd || !yyyy) return null;
    const date = new Date(`${yyyy}-${mm}-${dd}`);
    return isNaN(date) ? null : `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
  };

  React.useEffect(() => {
    setTextInput(formatDate(orderingEnd));
  }, [orderingEnd]);

  const handleInputChange = (e) => {
    const val = e.target.value;
    setTextInput(val);

    // Validate and update orderingEnd only if valid date
    const parsed = parseDate(val);
    if (parsed) {
      setOrderingEnd(parsed);
    }
  };


  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const allAuthors = [...new Set(
    eventBookData.flatMap(book =>
      book.authorBookDataAdded.map(a => a.author_name)
    )
  )].join(", ");

  // console.log("eventBookData", eventBookData?.book_data);
  // console.log("eventBookData", eventBookData)

  // const handleDeleteAuthor = (authorId) => {
  //   const updatedData = eventBookData.map((books) => {
  //     return {
  //       ...books,
  //       authorBookDataAdded: books.authorBookDataAdded.filter(
  //         (aubooks) => books.authorData.author_id !== authorId
  //       ),
  //     };
  //   });

  //   setEventBookData(updatedData);
  // };

const handleDeleteAuthor11 = (authorId) => {
  Swal.fire({
    title: "Are you sure?",
    text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Yes, delete it!",
  }).then((result) => {
    if (result.isConfirmed) {
      const updatedData = eventBookData.map((books) => {
        return {
          ...books,
          authorBookDataAdded: books.authorBookDataAdded.filter(
            () => books.authorData.author_id !== authorId
          ),
        };
      });

      setEventBookData(updatedData);

      Swal.fire("Deleted!", "Author has been removed.", "success");
    }
  });
};

 const handleDeleteAuthor = (authorIndex) => {
  // console.log("authorIndex :",authorIndex)
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this author?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete",
            cancelButtonText: "Cancel",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await axios.post(
                        `${process.env.REACT_APP_API_BASE_URL}authormeetapi/delete_event_author.php`,
                        {
                            event_id: id,
                            authorIndex: authorIndex
                        }
                    );

                    const res = response.data;

                    if (res.status) {
                        // ✅ Update frontend state
                        setEventBookData((prev) => prev.filter((_, i) => i !== authorIndex));

                        Swal.fire({
                            title: "Deleted!",
                            text: "Author has been deleted.",
                            icon: "success",
                            timer: 1500,
                            showConfirmButton: false,
                        });
                    } else {
                        throw new Error(res.message || "Delete failed");
                    }

                } catch (err) {
                    Swal.fire(
                        "Error",
                        err.response?.data?.message || err.message || "Something went wrong",
                        "error"
                    );
                }
            }
        });
    }

    // console.log("eventBookData :" , eventBookData)

  return (
    <>
      <AdminHeader />
      <div className={eventmanagedetailStyle.eventmanagementdetailspage} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-3'>
              <AdminSideBar />
            </div>
            <div className="col-lg-9">
              <div className={eventmanagedetailStyle.eventdetailBody}>
                <div className={eventmanagedetailStyle.eventdetailtopBox}>
                  <div className="row mb-4">
                    {/* <div className="col-xl-4">
                    <button onClick={handleClick} className={`${eventmanagedetailStyle.eventdetailbackBtn} btn btn-primary me-auto`}>Back</button>
                  </div> */}
                    <div className="col-xl-8">
                      <div className="d-flex align-items-center justify-content-end">
                        <div className='d-flex align-items-center justify-content-end'>
                          <span className={`${eventmanagedetailStyle.eventstatusText} me-3`}>Event Status:</span>
                          <div className="form-check form-switch me-3">
                            <input className="form-check-input" type="checkbox" id="activate" onClick={() => handleActivate('Approved')} checked={eventData.status == 'Approved'} />
                            <label className={`${eventmanagedetailStyle.eventdetaillabel} form-check-label`} for="Approved">Approved</label>
                          </div>
                        </div>
                        <div className="form-check form-switch me-3">
                          <input className="form-check-input" type="checkbox" id="activate" onClick={() => handleActivate('Not Approved')} checked={eventData.status == 'Not Approved'} />
                          <label className={`${eventmanagedetailStyle.eventdetaillabel} form-check-label`} for="NotApproved">Not Approved</label>
                        </div>
                        <div className="form-check form-switch">
                          <input className="form-check-input" type="checkbox" id="activate" onClick={() => handleActivate('Waiting for Approval')} checked={eventData.status == 'Waiting for Approval'} />
                          <label className={`${eventmanagedetailStyle.eventdetaillabel} form-check-label`} for="WaitingForApproval">Waiting For Approval</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-12">
                      <h2> {eventData.school_name} </h2>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-5">
                      <div className={`${eventmanagedetailStyle.eventdetailtopleft}`}>
                        <div className="d-flex align-items-start">
                          <p style={{ whiteSpace: 'nowrap' }}> <b> Event Name: </b> &nbsp;&nbsp;</p>
                          <span> {eventData.event_name} </span>
                        </div>
                        <p><b> Event Start Date: </b> &nbsp;&nbsp;{formatDate(eventData.event_start_date)} </p>
                        <p><b> Event End Date: </b> &nbsp;&nbsp;{formatDate(eventData.event_end_date)} </p>
                        <p><b> Time: </b> &nbsp;&nbsp; {eventData?.event_start_time} - {eventData?.event_end_time} </p>
                        <p><b> Author/s </b> &nbsp;&nbsp;{allAuthors} </p>
                        {/*  <p className="p-0"><b> Ordering Window: </b> &nbsp;&nbsp; </p> */}
                        <p><b> Ordering Window: </b> {formatToMMDDYYYY(eventData.event_order_date)}</p>

                        <div className="mb-3">


                          <div className="row mt-2">
                            <div className="col-md-5">
                              <DatePicker
                                value={orderingEnd}
                                onChange={(date) => setOrderingEnd(date)}
                                format="MM/dd/yyyy"
                                placeholder="MM/DD/YYYY"
                                style={{ width: "100%" }}
                              />
                            </div>

                            <div className="col-md-4">
                              <button
                                className={`${eventmanagedetailStyle.eventSave} btn btn-success`}
                                onClick={handleSaveOrderingWindow}
                              >
                                Update
                              </button>
                            </div>
                          </div>
                        </div>


                        {/* ************** ordering window end */}

                      </div>
                    </div>
                    <div className="col-xl-7">
                      <h3>Notes:</h3>
                      <textarea className={`${eventmanagedetailStyle.eventdetailTextarea} form-control w-100`} rows="7" name="note" onChange={handleNotesChange} value={notes} placeholder="Message" ></textarea>
                      <div className={`${eventmanagedetailStyle.eventdetailButtons} text-center`}>
                        <button type="button" className={`${eventmanagedetailStyle.eventCancel} btn btn-light me-3`} onClick={() => setNotes(eventData ? eventData.event_notes : '')}>Cancel</button>
                        <button type="button" className={`${eventmanagedetailStyle.eventSave} btn btn-success`} onClick={handleSaveNotes}>Save</button>
                      </div>
                    </div>
                  </div>
                </div>

                {eventBookData.length > 0 ? (
                  eventBookData.map((books, index) => (
                    books.authorBookDataAdded.map((aubooks, index) => (
                      <div className={eventmanagedetailStyle.eventdetailmidBox} key={index}>
                        <div className="row">
                          <div className="col-xl-5">
                            <div className="d-flex flex-wrap justify-content-between">
                              <div className={eventmanagedetailStyle.eventauthorDetails}>
                                <p><b> Name </b> &nbsp;&nbsp;{aubooks?.author_name}</p>
                                <p><b> Website </b> &nbsp;&nbsp;<Link to="">{books?.authorData?.website}</Link></p>
                                <p><b> Email Address </b> &nbsp;&nbsp;{books?.authorData?.email_id}</p>
                                <p><b> Phone </b> &nbsp;&nbsp;123-456-7890</p>
                              </div>
                              <div className="align-items-center">
                                <div className={`${eventmanagedetailStyle.eventdetailAuthorimg} mb-2`}>
                                  <img src={`${process.env.REACT_APP_API_BASE_URL}authormeetapi/images/author/${books?.authorData?.author_id}.jpg`} className='img-fluid' />
                                </div>
                                <Link to={`/AdminAuthorProfilePage/${books?.authorData?.author_id}`} className={eventmanagedetailStyle.viewauthortext}>View Author Profile </Link>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-7">
                            <div className="table-responsive">
                              <table className={`${eventmanagedetailStyle.eventdetailTable} table table-striped table-bordered`}>
                                <thead>
                                  <tr>
                                    <th>Title</th>
                                    <th>ISBN</th>
                                    <th>Price</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {aubooks.books.map((aubooksdetails, index) => (
                                    <tr key={index}>
                                      <td>{aubooksdetails.title}</td>
                                      <td>{aubooksdetails.isbn}</td>
                                      <td className='text-nowrap'>$ {aubooksdetails.price}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                            <div className={`${eventmanagedetailStyle.eventdetailIncription} d-flex justify-content-between align-items-center`}>
                              <h5>Inscription Report: &nbsp;&nbsp;
                                <Link to={`/InscriptionReportPage/${books?.authorData?.author_id}?event_id=${eventData.tbl_event_id}`}> <FaMagnifyingGlass className={eventmanagedetailStyle.eventdetailIncIcon} /> </Link>
                               
                              </h5>
                               <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDeleteAuthor(index)}
                                >
                                  Delete Author
                                </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ))
                ):null}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}
